import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { NAME_REGEX } from 'common-constants/validation';
import { TextField } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const InputFirstName = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="firstName"
      control={control}
      defaultValue={prefill}
      rules={{
        required: 'This field is required.',
        pattern: {
          value: NAME_REGEX,
          message: 'First name can only contain alphabetic, and certain special characters (\',-, ).',
        },
      }}
    >
      <TextField fullWidth label="First Name" />
    </ValidatedTextField>
  );
};

export default InputFirstName;
